import { gql } from '@apollo/client'

export const GET_CARRIER_IMPORT_ASYNC_TASK = gql`
  query carrierImportAsyncTask($taskId: String!) {
    carrierImportAsyncTask(taskId: $taskId) {
      taskId
      status
      progressPercentage
      progressMessage
      result
      errorMessage
    }
  }
`

export const GET_CARRIER_IMPORT_BATCHES = gql`
  query carrierImportBatches(
    $limit: Int
    $offset: Int
    $carrierId: ID
    $orderBy: String
  ) {
    carrierImportBatches(
      limit: $limit
      offset: $offset
      carrierId: $carrierId
      orderBy: $orderBy
    ) {
      id
      carrier {
        id
        name
      }
      asOfDate
      uploadedBy {
        id
        firstName
        lastName
      }
      uploadedAt
      originalFilename
      fileHash
      rowCount
      processedCount
      matchedCount
      unmatchedCount
      errorsCount
      metadata
    }
  }
`

export const GET_CARRIER_IMPORT_BATCH = gql`
  query carrierImportBatch($id: ID!) {
    carrierImportBatch(id: $id) {
      id
      carrier {
        id
        name
      }
      asOfDate
      uploadedBy {
        id
        firstName
        lastName
      }
      uploadedAt
      originalFilename
      fileHash
      rowCount
      processedCount
      matchedCount
      unmatchedCount
      errorsCount
      metadata
    }
  }
`

export const GET_CARRIER_IMPORT_BATCH_UNMATCHED = gql`
  query carrierImportBatchUnmatched($batchId: ID!) {
    carrierImportBatchUnmatched(batchId: $batchId) {
      rowNumber
      memberId
      name
      reason
      rawRowJson
      carrierStatusRaw
      carrierStatusGeneric
      systemPolicyStatus
      systemAgentName
      systemAgentEmail
    }
  }
`

export const GET_POLICY_CARRIER_LAST_SNAPSHOT = gql`
  query policyCarrierLastSnapshot($policyId: ID!) {
    policyCarrierLastSnapshot(policyId: $policyId) {
      id
      asOfDate
      carrierStatusRaw
      statusGeneric
      effectiveDate
      termDate
      paidThroughDate
      balance
      premium
      autopay
      eligibleForCommission
      policyNumber
      memberCarrierId
      memberDob
      memberFirstName
      memberLastName
      derivedFlags
      matchMethod
      matchConfidence
      rowNumber
      unmatchedReason
      systemPolicyStatus
      systemAgentName
      systemAgentEmail
      rawRow
      batch {
        id
        asOfDate
        uploadedAt
        originalFilename
        uploadedBy {
          id
          firstName
          lastName
        }
        carrier {
          id
          name
        }
      }
    }
  }
`
